document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".pdl-mega-trigger");

  triggers.forEach(function (trigger) {
    const link = trigger.querySelector(".pdl-mega-main-link");

    if (!link) return;

    link.addEventListener("click", function (event) {
      if (window.innerWidth <= 990) {
        event.preventDefault();
        trigger.classList.toggle("is-open");
      }
    });
  });
});